import { HallReportProps, PaymentsBalances, PaymentsReportMap, PaymentsReportResponse } from "../components/Halls/Form/interface";
import api from "./index";

export const reportsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        paymentsReport: builder.query<PaymentsReportMap, HallReportProps>({
            query: data => ({
                url: "hall/report/payments",
                method: "POST",
                data,
            }),
            transformResponse: (response: DefaultResponse<PaymentsReportResponse>) => {
                const ret: PaymentsReportMap = { from: response.data.from, to: response.data.to, halls: {}, total: response.data.total, actions: response.data.actions };
                response.data.halls.forEach(item => {
                    if (!(item.hall_id in ret.halls)) {
                        ret.halls[item.hall_id] = {};
                    }
                    if (!(item.service in ret.halls[item.hall_id])) {
                        ret.halls[item.hall_id][item.service] = {};
                    }
                    if (!(item.type in ret.halls[item.hall_id][item.service])) {
                        ret.halls[item.hall_id][item.service][item.type] = item;
                    }
                });
                return ret;
            },
            providesTags: ["payments-balances"],
        }),
        paymentsBalances: builder.mutation<PaymentsBalances, string>({
            query: service => ({
                url: "hall/balance-payments",
                method: "POST",
                data: { services: [service] },
            }),
            transformResponse: (response: DefaultResponse<PaymentsBalances>) => response.data,
            invalidatesTags: ["payments-balances"],
        }),
        modifyPaymentsBalance: builder.mutation<boolean, { currency: string, amount: number, service: string, wallet?: string }>({
            query: data => ({
                url: "hall/balance-payments-modify",
                method: "POST",
                data,
            }),
            transformResponse: (response: DefaultResponse<boolean>) => response.data,
            invalidatesTags: ["payments-balances"],
        }),
    }),
});

export const { usePaymentsReportQuery, usePaymentsBalancesMutation, useModifyPaymentsBalanceMutation } = reportsApi;